<template>
  <el-dialog title="订单详情" :visible.sync="formVisible" :close-on-click-modal="false" width="1000px">
    <el-descriptions class="margin-top" title="" :column="1" size="small" border>
      <el-descriptions-item label="推送状态" labelClassName="label-sty">
        <el-button type="success" plain size="mini" v-if="info.isSendedYongyou">推送成功</el-button>
        <el-button type="danger" plain size="mini" v-else>推送失败</el-button>
      </el-descriptions-item>
      <el-descriptions-item label="订单类型" labelClassName="label-sty">
        {{info.type | setType}}
      </el-descriptions-item>
      <el-descriptions-item label="订单编号" labelClassName="label-sty">
        {{info.orderNum}}
      </el-descriptions-item>
      <el-descriptions-item label="订单创建时间" labelClassName="label-sty">
        {{info.createdTime}}
      </el-descriptions-item>
      <!-- <el-descriptions-item label="添加单据池时间" labelClassName="label-sty">
        {{info.orderNum}}
      </el-descriptions-item> -->
      <el-descriptions-item label="推送成功时间" labelClassName="label-sty">
        {{info.sendTime}}
      </el-descriptions-item>
      <el-descriptions-item label="订单状态" labelClassName="label-sty">
        {{info.state | setState}}
      </el-descriptions-item>
      <el-descriptions-item label="城市公司" labelClassName="label-sty">
        {{info.cityName}}
      </el-descriptions-item>
      <el-descriptions-item label="返回参数" labelClassName="label-sty" v-if="returnParameter">
        {{returnParameter}}
      </el-descriptions-item>
    </el-descriptions>
    <template v-if="sendLog">
      <el-descriptions :column="3">
        <el-descriptions-item label="凭证编码">{{sendLog.dto && sendLog.dto.ExternalCode}}</el-descriptions-item>
        <el-descriptions-item label="凭证日期"> {{formatDate(sendLog.dto && sendLog.dto.VoucherDate)}}</el-descriptions-item>
        <el-descriptions-item label="城市公司"> {{info.sendLog && info.sendLog.cityCompanyName}}</el-descriptions-item>
      </el-descriptions>
      <el-table :data="sendLog.dto && sendLog.dto.Entrys">
        <el-table-column label="科目" prop="Account.Code" align="center" />
        <el-table-column label="金额" prop="AmountCr" align="center" />
        <el-table-column label="客户编码" prop="AuxInfos.AuxAccCustomer.Code" align="center" />
        <el-table-column label="备注" prop="Summary" align="center" />
      </el-table>
    </template>
  </el-dialog>
</template>

<script>
import dayjs from 'dayjs'
export default {
  data() {
    return {
      formVisible: false,
      info: {},
      returnParameter: null
    }
  },
  created() {

  },
  filters: {
    setState(i) {
      const Maps = new Map([
        [0, '已取消'],
        [1, '待支付'],
        [2, '待发货'],
        [3, '已发货'],
        [4, '已完成'],
        [-1, '已失效']
      ])
      return Maps.get(i)
    },
    setType(i) {
      const Maps = new Map([
        [1, '订货订单'],
        [2, '积分订单'],
        [3, '秒杀订单'],
        [4, '换货订单']
      ])
      return Maps.get(i)
    }
  },
  methods: {
    resetForm() {
      this.info = {}
    },
    handleCreate(row) {
      console.log('row: ', row);
      this.resetForm()
      this.info = { ...row }
      this.sendLog = row.sendLog && row.sendLog.requestParameter ? JSON.parse(row.sendLog.requestParameter) : null;
      this.returnParameter = row.sendLog && row.sendLog.returnParameter ? JSON.parse(row.sendLog.returnParameter) : null;
      this.formVisible = true
    },
    formatDate(date) {
      if (!date)  return ''
      return dayjs(date).format('YYYY-MM-DD HH:mm:ss')
    }
  }
}
</script>
<style lang="scss" scoped>
::v-deep .el-descriptions-item__label {
  width: 20% !important;
}
::v-deep .el-button--success.is-plain:focus,
.el-button--success.is-plain:hover {
  color: #67c23a;
  background: #f0f9eb;
  border-color: #c2e7b0;
}
</style>
